import { memo } from 'react';
import type { FormLabelProps as MUIFormLabelProps } from '@mui/material';
import { FormLabel as MuiFormLabel, styled } from '@mui/material';
import Typography from '../Typography';

export type FormLabelProps = MUIFormLabelProps;

const StyledFormLabel = styled(MuiFormLabel)`
  padding: 0;
`;

const FormLabel: React.FC<FormLabelProps> = ({ children, ...props }) => (
  <StyledFormLabel {...props}>
    <Typography variant="body2-bold" color="text.primary">
      {children}
    </Typography>
  </StyledFormLabel>
);

export default memo(FormLabel);
